import httpClient from "@/api/httpClient";
import ExtraPage from "@/model/ExtraPage";
import ExtraRequest from "@/model/ExtraRequest";
import ExtraResponse from "@/model/ExtraResponse";

function listExtras(
  accessToken: string,
  page: number,
  size: number
): Promise<ExtraPage> {
  return httpClient.getJson<ExtraPage>(
    `/api/extras?page=${page}&size=${size}`,
    accessToken
  );
}

function getExtraById(
  accessToken: string,
  id: string
): Promise<ExtraResponse> {
  return httpClient.getJson<ExtraResponse>(`/api/extras/${id}`, accessToken);
}

function createExtra(
  accessToken: string,
  request: ExtraRequest
): Promise<ExtraResponse> {
  return httpClient.postJson<ExtraResponse>(
    "/api/extras",
    request,
    accessToken
  );
}

function updateExtra(
  accessToken: string,
  id: string,
  request: ExtraRequest
): Promise<ExtraResponse> {
  return httpClient.putJsonBody<ExtraResponse>(
    `/api/extras/${id}`,
    request,
    accessToken
  );
}

function deleteExtra(accessToken: string, id: string): Promise<void> {
  return httpClient.deleteNoContent(`/api/extras/${id}`, accessToken);
}

const extrasApi = {
  listExtras,
  getExtraById,
  createExtra,
  updateExtra,
  deleteExtra,
};

export default extrasApi;
